export default __webpack_public_path__ + "static/media/ambi5.15313fc7.png";